import React, { useEffect, useState } from 'react';
import styles from './SelectedSpecies.module.css'
const SelectedSpecies = ({ showSelected, setShowSelected }) => {
    // console.log(showSelected)
    const def_att = showSelected.taxon?.default_photo?.attribution
    const def_img = showSelected.taxon?.default_photo?.medium_url
    const taxonId = showSelected.taxon?.id
    const openTaxaDetails = () => {
        const taxonLink = `https://www.inaturalist.org/taxa/${taxonId}`
        window.open(taxonLink, '_blank')
    }

    const license = showSelected.taxon.default_photo.license_code;

    let nImages = 10
    const [images, setImages] = useState([])
    const [imgCounter, setImgCounter] = useState(0)
    const [image, setImage] = useState({ url: license === null ? './img/loading.gif' : def_img, att: def_att })
    const photosUrl = `https://api.inaturalist.org/v1/observations?photos=true&licensed=true&photo_licensed=true&license=cc-by%2Ccc-by-nc%2Ccc-by-nd%2Ccc-by-sa%2Ccc-by-nc-nd%2Ccc-by-nc-sa%2Ccc0&photo_license=cc-by%2Ccc-by-nc%2Ccc-by-nd%2Ccc-by-sa%2Ccc-by-nc-nd%2Ccc-by-nc-sa%2Ccc0&taxon_id=${taxonId}&quality_grade=research&page=1&per_page=${nImages}&order=desc&order_by=votes`

    useEffect(
        () => {
            if ((license === null && images.length === 0) || (imgCounter !== 0 && images.length === 0)) { // initial state
                setImage((im) => ({ ...im, url: '/img/loading.gif' }))
                console.log('FETCHING IMAGES')
                fetch(photosUrl)
                    .then(res => res.json())
                    .then(speciesInfo => {
                        let photos = speciesInfo.results.map(results =>
                        ({
                            url: results.photos[0].url.replace('square', 'medium'),
                            att: results.photos[0].attribution
                        })
                        )
                        if (license !== null) {
                            photos = [
                                {
                                    url: showSelected.taxon?.default_photo?.medium_url,
                                    att: showSelected.taxon?.default_photo?.attribution
                                },
                                ...photos
                            ]
                            setImage(photos[1])
                        } else {
                            setImage(photos[0])
                        }

                        console.log('IMAGES FETCHED')
                        setImages(photos)
                        // preload images for quick transition
                        for (const image of photos) {
                            const imageElement = new Image();
                            imageElement.src = image.url;
                        }
                    })
                    .catch(() => {
                        // offline: fall back to the (cached) default photo
                        setImage({ url: def_img, att: def_att })
                        setImages([{ url: def_img, att: def_att }])
                    })
                return () => { console.log('clean up (placeholder)') }
            }

        },

        [imgCounter, images, license, photosUrl, showSelected, def_att, def_img]
    )


    // eslint-disable-next-line
    function incrementImgCounter(increment) {
        console.log('incrementing counter')
        const i = imgCounter + increment
        if (i < 0 | i === nImages - 1) return
        setImage({ ...image, url: './img/loading.gif' })
        setImage(images[i])
        setImgCounter(i)
    }

    // Handle swipe
    const [touchStart, setTouchStart] = useState(null)
    const [touchEnd, setTouchEnd] = useState(null)

    // the required distance between touchStart and touchEnd to be detected as a swipe
    const minSwipeDistance = 50

    const onTouchStart = (e) => {
        setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
        setTouchStart(e.targetTouches[0].clientX)
    }

    const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (isLeftSwipe || isRightSwipe) console.log('swipe', isLeftSwipe ? 'left' : 'right')
        // add your conditional logic here
        if (isLeftSwipe) incrementImgCounter(-1)
        if (isRightSwipe) incrementImgCounter(1)

    }

    useEffect(() => {
        const keyLog = (e) => {
            if (e.key === "ArrowLeft") incrementImgCounter(-1)
            if (e.key === "ArrowRight") incrementImgCounter(1)
            if (e.key === "Escape") setShowSelected('')
        }
        window.addEventListener('keydown', keyLog)
        return () => window.removeEventListener('keydown', keyLog)
    }, [nImages, images, imgCounter, incrementImgCounter, setShowSelected])

    const att = image?.att
    const url = image?.url
    return (
        <div className={styles.absolutebg} onClick={() => { setShowSelected('') }} >
            <div className={styles.panel} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
                <div className={styles.close}></div>
                <div className={styles.imagecontainer} onClick={(e) => { e.stopPropagation() }}>
                    <button className={styles.buttonLeft} onClick={() => incrementImgCounter(-1)}>&laquo;</button>
                    <img alt={att} className={styles.image} src={url} onClick={openTaxaDetails} />
                    <button className={styles.buttonRight} onClick={() => incrementImgCounter(1)}> &raquo;</button>
                </div>
                <div className={styles.attribution} onClick={(e) => { e.stopPropagation() }}>
                    {image?.att}
                    <div className={styles.imgNav}>
                        <button type='button' className={styles.link} onClick={openTaxaDetails} >More info</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectedSpecies;